module.exports = __webpack_public_path__ + "static/media/onboarding_products.43e6c09e.jpg";